module.exports = __webpack_public_path__ + "img/EQUAL.b7377618.svg";